import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';


import { map } from 'lodash';
import addOns from '../../../core/add-ons';

import AutoScale from 'react-auto-scale';
import { _Label, _Field, _Slider, _Heading } from '../styled-sidebar';
import Slider from 'material-ui/Slider';
import { StyledScrollable, StyledMargin } from '../../common/styled-base';
import { lowerCamelCaseToRegular } from '../../../core/utils';

import { setThematic, getChart, setHeading, setSubheading } from '../../../core/chart';

import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/MenuItem';
import theme from '../../../styles/theme';

import { Box } from 'rebass';
import FontPicker from '../../common/font-picker';

import StyledColorBlock from '../../common/styled-color-block';
import ColorPicker from '../../common/color-picker';
import { colorToString } from '../../../core/utils';

class AddOnsMenu extends React.Component {

  render() {
    const { 
      thematic, setThematic,
      heading, setHeading,
      subheading, setSubheading,
    } = this.props;

    const themes = [
      'none',
      'minimalist-turtle',
      'minimalist-toucan',
      'minimalist-whale',
      'minimalist-lady-bug',
      'minimalist-crab',
      'minimalist-fox',
      'minimalist-pig',
      'safari-giraffe',
      'safari-hippo',
    ]
    const options = ['none', 'decal']
    return (
      <StyledScrollable padding='15px'>

        <_Field>
          <_Heading>Heading</_Heading>
        </_Field>

        <_Field>
          <_Label>Heading Text</_Label>
          <TextField 
            id="heading" 
            className="kt-textfield"
            value={heading.text}
            inputStyle={{color: 'rgba(255,255,255,0.8'}}
            underlineFocusStyle={{borderColor: theme.primary}}
            onChange={(e, value) => setHeading({...heading, text: value})}
            />
        </_Field>
        <_Field>
          <_Label>Heading Font</_Label>

          <FontPicker
            onChange={value => setHeading({ ...heading, fontFamily: value })}
            value={heading.fontFamily}
          />

        </_Field>
        <_Field>
          <_Label>Heading Font Size: {heading.fontSize}</_Label>
          <_Slider>
            <Slider 
              disableFocusRipple={true}
              className="slider-ui"
              min={20} 
              max={200} 
              step={1} 
              value={heading.fontSize} 
              onChange={(e, value) => setHeading({...heading, fontSize: value})} />
          </_Slider>
        </_Field>
        <_Field>
          <_Label>Heading Margin: {heading.margin}</_Label>
          <_Slider>
            <Slider 
              disableFocusRipple={true}
              className="slider-ui"
              min={0} 
              max={200} 
              step={1} 
              value={heading.margin} 
              onChange={(e, value) => setHeading({...heading, margin: value})} />
          </_Slider>
        </_Field>
        <_Field>
          <_Label>Heading Color</_Label>
          <StyledMargin marginTop="5px">
            <ColorPicker color={heading.textColor} onChange={(color) => setHeading({...heading, textColor: colorToString(color)})}>
              <StyledColorBlock color={heading.textColor} />
            </ColorPicker>
          </StyledMargin>
        </_Field>

        <_Field className="mt3">
          <_Heading>Subheading</_Heading>
        </_Field>
        
        <_Field>
          <_Label>Subheading Text</_Label>
          <TextField 
            id="subheading" 
            className="kt-textfield"
            value={subheading.text}
            inputStyle={{color: 'rgba(255,255,255,0.8'}}
            underlineFocusStyle={{borderColor: theme.primary}}
            onChange={(e, value) => setSubheading({...subheading, text: value})}
            />
        </_Field>

        <_Field>
          <_Label>Subheading Font</_Label>

          <FontPicker
            onChange={value => setSubheading({ ...subheading, fontFamily: value })}
            value={subheading.fontFamily}
          />
        </_Field>

        <_Field>
          <_Label>Subheading Font Size: {subheading.fontSize}</_Label>
          <_Slider>
            <Slider 
              disableFocusRipple={true}
              className="slider-ui"
              min={20} 
              max={200} 
              step={1} 
              value={subheading.fontSize} 
              onChange={(e, value) => setSubheading({...subheading, fontSize: value})} />
          </_Slider>
        </_Field>
        <_Field>
          <_Label>Subheading Margin: {subheading.margin}</_Label>
          <_Slider>
            <Slider 
              disableFocusRipple={true}
              className="slider-ui"
              min={-30} 
              max={200} 
              step={1} 
              value={subheading.margin} 
              onChange={(e, value) => setSubheading({...subheading, margin: value})} />
          </_Slider>
        </_Field>
        <_Field>
          <_Label>Subheading Color</_Label>
          <StyledMargin marginTop="5px">
            <ColorPicker color={subheading.textColor} onChange={(color) => setSubheading({...subheading, textColor: colorToString(color)})}>
              <StyledColorBlock color={subheading.textColor} />
            </ColorPicker>
          </StyledMargin>
        </_Field>

      </StyledScrollable>
    )
  }
}

const mapStateToProps = createSelector(
  getChart,
  (chart) => ({
    thematic: chart.thematic,
    heading: chart.heading,
    subheading: chart.subheading,
  })  
)

const mapDispatchToProps = {
  setThematic,
  setHeading,
  setSubheading,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddOnsMenu);


// WEBPACK FOOTER //
// ./src/components/menu/add-ons-menu/index.js